import React from "react";
import { FormattedMessage } from "react-intl";
import { Icon, Table } from "semantic-ui-react";
import { BiUserCheck, BiUserX } from "react-icons/bi";
import styles from "./UserListRow.module.scss";
import { useSelector } from "react-redux";
import { usersDeleteSelector } from "../../../utils/selectors";
import ConfirmButtons from "../../../components/ConfirmButtons";

const UserListRow = ({
  user: { _id, name, email, isAdmin, deletedAt },
}: {
  user: any;
}) => {
 
  const { loading } = useSelector((state) => usersDeleteSelector(state));

  return (
    <Table.Row>
      <Table.Cell>
        <small>{_id}</small>
      </Table.Cell>
      <Table.Cell>{name}</Table.Cell>
      <Table.Cell>
        <a href={`mailto:${email}`}>{email}</a>
      </Table.Cell>
      <Table.Cell>
        <FormattedMessage
          id={`admin.list.${isAdmin ? "isAdmin" : "notAdmin"}`}
        />{" "}
        {isAdmin ? <BiUserCheck color={"green"} /> : <BiUserX color={"red"} />}
      </Table.Cell>
      <Table.Cell>
        {deletedAt ? (
  <FormattedMessage
    id="admin.list.user.deletedOn"
    values={{ date: new Date(deletedAt).toLocaleDateString() }}
  />
) : (
  <FormattedMessage id="admin.list.user.active" />
)}
      </Table.Cell>
    <Table.Cell className={styles.row}>
        {loading ? (
          <Icon loading name="spinner" size="big" />
        ) : (
          <ConfirmButtons
            link={`/admin/users/${_id}/edit`}
            confirmText={
              <FormattedMessage id={"admin.adminList.confirmUserDelete"} />
            }
            showDelete={false}
          />
        )}
      </Table.Cell>
    </Table.Row>
  );
};

export default UserListRow;
